import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import { UPDropdownItem } from 'components/dropdown';
import { IApiError } from 'types/errors';
import { ApiErrorFilters } from 'types/errors/ApiErrorFilters';
import { PaginatedList } from 'types/PaginatedList';

export const getEventLogsRequest = async (filters: ApiErrorFilters): Promise<PaginatedList<IApiError>> => {
  const response: AxiosResponse<PaginatedList<IApiError>> = await getApi().post(`Event/GetEvents`, filters);
  return response.data;
};

export const archiveEventsRequest = async (errorIds: number[]): Promise<void> => {
  await getApi().post(`Event/Archive`, errorIds);
};

export const getEventTypesRequest = async (): Promise<UPDropdownItem[]> => {
  const response: AxiosResponse<UPDropdownItem[]> = await getApi().get(`Event/GetErrorTypes`);
  return response.data;
};
